import { Menu, MenuItem } from "@mui/material";
import { organizationsApi } from "api";
import React, { useCallback, useEffect, useState } from "react";
import { GroupAssociation } from "../UserSelectedPanel";

interface GroupsMenuProps {
  anchor: null | HTMLElement;
  onLink: (id: number) => void;
  associated: Array<GroupAssociation>;
  onClose: Function;
  organizationId: number;
}

const GroupsMenu: React.FC<GroupsMenuProps> = ({
  anchor,
  onLink,
  associated,
  onClose,
  organizationId,
}) => {
  const [voices, setVoices] = useState<Array<GroupAssociation>>([]);

  const getGroups = useCallback(async () => {
    try {
      const response = await organizationsApi.get<{
        groups: Array<GroupAssociation>;
      }>(`${organizationId}/groups`);
      setVoices(
        response.data.groups.filter(
          (x) => !associated.map((_) => _.id).includes(x.id)
        )
      );
    } catch {
    } finally {
    }
  }, [organizationId, associated]);

  useEffect(() => {
    if (Boolean(anchor)) {
      getGroups();
    }
  }, [anchor, getGroups]);

  return (
    <Menu
      open={voices.length > 0 ? Boolean(anchor) : false}
      onClose={() => onClose()}
      anchorEl={anchor}
    >
      {voices.map(({ name, id }) => (
        <MenuItem
          id={`menu-group-${id}`}
          key={`menu-group-${id}`}
          onClick={() => onLink(id)}
        >
          {name}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default GroupsMenu;
